import { FacebookPostSizeMode } from '@core/models';

export const getSocialPostSizeMode = (sizeMode: FacebookPostSizeMode) => {
  switch (sizeMode) {
    case FacebookPostSizeMode.Landscape:
      return [1080, 566];
    case FacebookPostSizeMode.Square:
      return [1080, 1080];
  }
};
